<div style="display: flex; white-space: nowrap; gap: 30px" [attr.inert]="disabled ? '' : null" [style.opacity]="disabled ? 0.4 : 1">
    <div class="col-lg-4 col-xl-3 entity-panel">
        <div class="card panel-flat-color secondary-panel small-panel select-entity" style="margin-bottom: 0">
            <div class="panel-flat-header small-header">
                <h3>Attachment Location</h3>
            </div>
            <select
                multiple
                id="attachment-locations"
                class="entity-list"
                [(ngModel)]="report.criteria.attachmentLocations"
                [class.loading-list]="areAttachmentLocationOptionsLoading"
                (change)="onSelectedAttachmentLocationsChanged($event)"
            >
                @for (location of attachmentLocationOptions; track location) {
                    <option [ngValue]="location.id"
                        >{{ location.label }}
                    </option>
                }
            </select>
        </div>
        <div style="display: flex; align-items: flex-start; justify-content: space-between; gap: 1rem">
            <div class="checkbox">
                <label
                    style="
                        flex: 1 1 auto;
                        margin: 0;
                        min-width: 0;
                        white-space: normal;
                        word-wrap: break-word;
                        hyphens: auto;
                    "
                >
                    <input
                        type="checkbox"
                        [(ngModel)]="report.criteria.ignoreConditionalFilterOptions"
                        (change)="onIgnoreConditionalFilterOptionsChanged()"
                    />
                    Show attachment types that won't be filtered by all the entity selections
                </label>
            </div>

            @if (!!report.criteria.attachmentLocations && attachmentLocationOptions.length) {
                <div style="flex: 0 0 auto; align-self: flex-start">
                    @if (report.criteria.attachmentLocations.length != attachmentLocationOptions.length) {
                        <button class="ace-btn btn-sm btn-primary" (click)="selectAllAttachmentLocations()">
                            Select All
                        </button>
                    }
                    @if (report.criteria.attachmentLocations.length == attachmentLocationOptions.length) {
                        <button class="ace-btn btn-sm btn-primary" (click)="unselectAllAttachmentLocations()">
                            Unselect All
                        </button>
                    }
                </div>
            }
        </div>
    </div>
    <div class="col-lg-4 col-xl-3 entity-panel">
        <div class="card panel-flat-color secondary-panel small-panel select-entity" style="margin-bottom: 0">
            <div class="panel-flat-header small-header">
                <h3>Attachment Types</h3>
            </div>
            <select
                multiple
                id="attachment-types"
                class="entity-list"
                [(ngModel)] = "report.criteria.attachmentTypes"
                [class.loading-list]="areAttachmentTypeOptionsLoading"
            >
                @for (type of attachmentTypeOptions; track type) {
                    <option [ngValue]="type.id"
                        >{{ type.label }}
                    </option>
                }
            </select>
        </div>
        @if (attachmentTypeOptions.length) {
            <div class="float-end">
                @if (report.criteria.attachmentTypes.length != attachmentTypeOptions.length) {
                    <button class="ace-btn btn-sm btn-primary" (click)="selectAllAttachmentTypes()">
                        Select All
                    </button>
                }
                @if (report.criteria.attachmentTypes.length == attachmentTypeOptions.length) {
                    <button class="ace-btn btn-sm btn-primary" (click)="unselectAllAttachmentTypes()">
                        Unselect All
                    </button>
                }
            </div>
        }
    </div>
    <div style="display: flex; flex-direction: column; gap: 5px">
        <div style="display: flex; align-items: baseline; gap: 5px">
            <span style="font-weight: bold; flex: 0 0 75px">Tax Years:</span>
            <select
                [(ngModel)]="report.criteria.taxYearBegin"
                (change)="yearChangedValidation()"
                class="form-select-sm"
                style="width: 80px"
            >
                <option [ngValue]=""></option>
                @for (year of availableYears; track year) {
                    <option [ngValue]="year">{{ year }}</option>
                }
            </select>
            <span>to</span>
            <select
                [(ngModel)]="report.criteria.taxYearEnd"
                [disabled]="!report.criteria.taxYearBegin"
                class="form-select-sm report-manager-year-list"
                style="width: 80px"
            >
                <option [ngValue]=""></option>
                @for (year of availableYears; track year) {
                    <option [disabled]="year < report.criteria.taxYearBegin" [ngValue]="year">{{ year }}</option>
                }
            </select>
        </div>
        @if (showIncludeBlankTaxYearCheckbox) {
            <div class="checkbox" style="padding-left: 80px">
                <label style="font-weight: normal">
                    <input
                        type="checkbox"
                        [(ngModel)]="report.criteria.includeBlankTaxYear"
                    />
                    Include Blank
                </label>
            </div>
        }
    </div>
    @if (shouldShowPropertyTypeSelector()) {
        <div style="display: flex; gap: 5px; align-items: baseline">
            <label>Property Type: </label>
            <select multiple [(ngModel)]="report.criteria.propertyTypeIDs" class="form-select-sm" [disabled]="!isPropertyTypeSelectorEnabled()">
                @for (propType of propertyTypes; track propType) {
                    <option [ngValue]="propType.propertyTypeId">{{ propType.name }}</option>
                }
            </select>
        </div>
    }
</div>
